import { z } from 'zod'

// PC 앱 인쇄 서버(print.<도메인>/v1.0)는 Swagger 를 내지 않고 서버 소스도 이 저장소들 밖에 있다. 스키마는 teacher 가
// 쓰던 응답 타입과 화면이 읽는 필드를 근거로 손으로 썼다(2026-10-14 확인). 그래서 앱이 읽는 필드만 받는다.

/***************** 인쇄 순서 *****************/
// 여러 학생에게 배정된 학습지를 학생별로 묶어 찍을지, 배정일 순으로 찍을지
export const REMOTE_PRINT_ORDER = ['by-student', 'by-date'] as const

export const RemotePrintOrderSchema = z.enum(REMOTE_PRINT_ORDER)
export type RemotePrintOrder = z.infer<typeof RemotePrintOrderSchema>

/***************** 인쇄 에이전트 *****************/
export const PrinterSchema = z.object({
  name: z.string(),
  model: z.string(),
})
export type Printer = z.infer<typeof PrinterSchema>

/** 선생님 PC 에 설치된 PC 앱 하나. classId·address 는 앱이 읽지 않아 받지 않는다 */
export const PrintAgentSchema = z.object({
  machineId: z.string(),
  // 구버전 PC 앱은 PC 이름 대신 machineId(GUID)를 싣는다
  machineName: z.string(),
  // 프린터 목록에 빈 칸(null)이 섞여 오는 경우가 있어 화면이 건너뛴다
  printers: z.array(PrinterSchema.nullable()),
})
export type PrintAgent = z.infer<typeof PrintAgentSchema>

/** 인쇄 요청 응답. 서버는 data 를 늘 비우고 성공 여부를 result('0000' 이 성공)·message 로 알린다 */
export const RemotePrintResultSchema = z.object({
  data: z.null(),
  result: z.string(),
  message: z.string(),
})
export type RemotePrintResult = z.infer<typeof RemotePrintResultSchema>
